import { Controller } from "@hotwired/stimulus"
import Swal from "sweetalert2"

// Modal de geração de boleto (antes script inline). Abre o .modal (singleton),
// injeta o form (de um <template>), preenche os campos do gatilho e os dados do
// sacado e trata o submit via fetch + swal + Turbo. Datepicker via Stimulus
// (data-controller="datepicker").
export default class extends Controller {
  static targets = ["template"]
  static values = {
    origemType: String,
    origemId: String,
    issqn: Boolean,
    url: String,
    hasSacado: Boolean,
    sacado: Object
  }

  open(event) {
    event.preventDefault()

    const origemType = this.origemTypeValue
    const origemId = this.origemIdValue
    const issqn = this.issqnValue
    const urlPost = this.urlValue

    document.querySelector(".modal").classList.add("is-active")
    const modalContent = document.querySelector(".modal-content")
    modalContent.innerHTML = this.templateTarget.innerHTML
    modalContent.style.width = "40%"

    setTimeout(function () {
      document.querySelector("input[name='valor']").focus()
    }, 100)

    document.querySelector("input[name='resource_type']").value = origemType
    document.querySelector("input[name='resource_id']").value = origemId
    document.querySelector("input[name='issqn_retido']").checked = issqn
    document.querySelector("input[name='url']").value = urlPost

    if (this.hasSacadoValue) {
      const s = this.sacadoValue
      document.querySelector("#sacado_documento").textContent = s.documento
      document.querySelector("#sacado_nome").textContent = s.nome
      document.querySelector("#sacado_endereco").textContent = s.endereco
      document.querySelector("#sacado_bairro").textContent = s.bairro
      document.querySelector("#sacado_cep").textContent = s.cep
      document.querySelector("#sacado_cidade").textContent = s.cidade
      document.querySelector("#sacado_uf").textContent = s.uf
    } else {
      document.querySelector("#box-sacado").style.display = "none"
    }

    document.querySelector("#gerarBoleto").addEventListener("click", (e) => {
      e.preventDefault()
      const sacadoDocumento = document.querySelector("#sacado_documento").textContent
      const sacadoNome = document.querySelector("#sacado_nome").textContent
      const sacadoEndereco = document.querySelector("#sacado_endereco").textContent
      const sacadoBairro = document.querySelector("#sacado_bairro").textContent
      const sacadoCep = document.querySelector("#sacado_cep").textContent
      const sacadoCidade = document.querySelector("#sacado_cidade").textContent
      const sacadoUf = document.querySelector("#sacado_uf").textContent
      const dataVencimento = document.querySelector("input[name='data_vencimento']").value
      const observacao_1 = document.querySelector("input[name='observacao_1']").value
      const observacao_2 = document.querySelector("input[name='observacao_2']").value
      const observacao_3 = document.querySelector("input[name='observacao_3']").value
      const nf_discriminacao = document.querySelector("textarea[name='nf_discriminacao']").value
      const acompanhamento = document.querySelector("input[name='acompanhamento']").checked
      const issqnRetido = document.querySelector("input[name='issqn_retido']").checked
      const valor = document.querySelector("input[name='valor']").value
      const valor_bruto = document.querySelector("input[name='valor_bruto']").value
      const valor_servico = document.querySelector("input[name='valor_servico']").value

      if (!valor || valor === "" || valor === "0,00") {
        window.alert("Valor do boleto deve ser preenchida.")
        return
      }
      if (origemType !== "Associado" && (!valor_bruto || valor_bruto === "")) {
        window.alert("Valor bruto (bens/cupons) p/ geração da NF deve ser preenchida.")
        return
      }
      if (origemType !== "Associado" && (!valor_servico || valor_servico === "")) {
        window.alert("Valor do serviço p/ geração da NF deve ser preenchida.")
        return
      }
      if (!dataVencimento || dataVencimento === "") {
        window.alert("Data de vencimento não preenchida.")
        return
      }

      const montaParametros = {
        resource_type: origemType,
        resource_id: origemId,
        sacado_documento: sacadoDocumento,
        sacado_nome: sacadoNome,
        sacado_endereco: sacadoEndereco,
        sacado_bairro: sacadoBairro,
        sacado_cep: sacadoCep,
        sacado_cidade: sacadoCidade,
        sacado_uf: sacadoUf,
        data_vencimento: dataVencimento,
        observacao_1: observacao_1,
        observacao_2: observacao_2,
        observacao_3: observacao_3,
        nf_discriminacao: nf_discriminacao,
        acompanhamento: acompanhamento,
        issqn_retido: issqnRetido,
        valor: valor,
        valor_servico: valor_servico,
        valor_bruto: valor_bruto
      }

      document.querySelector("#gerarBoleto").textContent = "Gerando boleto, aguarde..."
      const token = document.querySelector('meta[name="csrf-token"]')?.content
      const body = new URLSearchParams()
      Object.entries(montaParametros).forEach(function (entry) {
        body.append("boleto[" + entry[0] + "]", entry[1])
      })

      fetch(urlPost, {
        method: "POST",
        headers: {
          "X-CSRF-Token": token,
          "Content-Type": "application/x-www-form-urlencoded"
        },
        body: body
      })
        .then((response) => {
          if (!response.ok) throw new Error("HTTP " + response.status)
          return response.json()
        })
        .then((data) => {
          if (!data.ok) {
            setTimeout(function () {
              Swal.fire({ title: data.titulo, text: data.mensagem, icon: "error", confirmButtonText: "OK" })
              document.querySelector("#gerarBoleto").textContent = "Gerar!"
            }, 300)
            return
          }
          setTimeout(function () {
            Swal.fire({ title: data.titulo, text: data.mensagem, icon: "success", confirmButtonText: "OK" })
              .then(function () {
                document.querySelector(".modal").classList.remove("is-active")
                Turbo.visit(data.url_redirecionada)
              })
            document.querySelector("#gerarBoleto").textContent = "Gerar!"
          }, 300)
        })
        .catch(() => { document.querySelector("#gerarBoleto").textContent = "Gerar!" })
    })

    document.querySelector("#fecharTelaBoleto").addEventListener("click", () => {
      document.querySelector(".modal").classList.remove("is-active")
    })
  }
}
